import React from 'react';
import { Helmet } from 'react-helmet-async';
import styles from './EvenementPage.module.css';

const EvenementPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Brands2buyers - Évènements</title>
        <meta name="description" content="Inscriptions pour Brands 2 Buyers, l'événement majeur en France dédié à la transformation digitale et à l'innovation dans le commerce B2B." />
        <meta property="og:title" content="Brands2buyers - Évènements" />
        <meta property="og:description" content="Inscriptions pour Brands 2 Buyers, l'événement majeur en France dédié à la transformation digitale et à l'innovation dans le commerce B2B." />
        <meta property="og:image" content="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/672cf5a8bc8cfc135ac0a3d3_B2B%20Social.png" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Brands2buyers - Évènements" />
        <meta name="twitter:description" content="Inscriptions pour Brands 2 Buyers, l'événement majeur en France dédié à la transformation digitale et à l'innovation dans le commerce B2B." />
        <meta name="twitter:image" content="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/672cf5a8bc8cfc135ac0a3d3_B2B%20Social.png" />
      </Helmet>
      {/* Hero Banner */}
      <section className={styles.hero}>
        <div className={styles.heroInner}>
          <div className={styles.heroContent}>
            <h1 className={styles.heroTitle}>NOS DERNIERS ÉVÈNEMENTS</h1>
          </div>
          <div className={styles.heroImageWrapper}>
            <img
              src="/assets/images/evenement-hero-illustration.jpg"
              alt="Évènements Brands2Buyers"
              className={styles.heroImage}
            />
          </div>
        </div>
      </section>

      {/* Section Title on white bg */}
      <div className={styles.sectionTitleWrapper}>
        <h2 className={styles.sectionTitle}>
          RETOUR SUR NOS DERNIERS ÉVÈNEMENTS
        </h2>
      </div>

      {/* Events Section */}
      <section className={styles.eventsSection}>
        <div className={styles.eventsContainer}>
          {/* Year Tab */}
          <div className={styles.tabsMenu}>
            {/* TODO: lier au filtre par année */}
            <button className={styles.yearBadge} onClick={() => {}}>2025</button>
          </div>

          {/* Event Card 1 */}
          <div className={styles.eventCard}>
            <img
              src="/assets/images/evenement-photo1.jpg"
              alt="Brands2Buyers Décembre 2025"
              className={styles.eventPhoto}
            />
            <h3 className={styles.eventTitle}>BRANDS2BUYERS - DEC. 25</h3>
            <p className={styles.eventDescription}>
              Un retour visuel sur Brands2Buyers édition 2 : des échanges aux
              interventions, en passant par les animations et le networking. Les
              meilleurs moments sont ici.
            </p>
            <div className={styles.eventButtons}>
              <a href="https://photos.app.goo.gl/hWqipGDMTaU3tZHz6" target="_blank" rel="noopener noreferrer" className={styles.btnPhotos}>VOIR LES PHOTOS</a>
              <a href="https://www.youtube.com/watch?v=wBnWv-bc4Os" target="_blank" rel="noopener noreferrer" className={styles.btnVideo}>VOIR LA VIDÉO</a>
              <button className={styles.separatorBtn} onClick={() => {}}>LES TABLES RONDES</button>
            </div>
          </div>

          {/* Year Tab 2 */}
          <div className={styles.tabsMenu}>
            {/* TODO: lier au filtre par année */}
            <button className={styles.yearBadge} onClick={() => {}}>2025</button>
          </div>

          {/* Event Card 2 */}
          <div className={styles.eventCard}>
            <img
              src="/assets/images/evenement-photo2.jpg"
              alt="Brands2Buyers Février 2025"
              className={styles.eventPhoto}
            />
            <h3 className={styles.eventTitle}>BRANDS2BUYERS - FEV. 25</h3>
            <p className={styles.eventDescription}>
              Retour en images sur le premier Brands2Buyers : une rencontre
              intense entre marques et acheteurs, rythmée par des échanges
              concrets et une belle dose d'énergie collective.
            </p>
            <div className={styles.eventButtons}>
              <a href="https://photos.app.goo.gl/XE9WoYkmg5dskVaV6" target="_blank" rel="noopener noreferrer" className={styles.btnPhotos}>VOIR LES PHOTOS</a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default EvenementPage;
